module.exports = __webpack_public_path__ + "img/pictureMen.270cb0a.png";